import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { z } from 'zod';
import { BlockCard } from '../lib/block-card.js';
import { sanitizeHref } from '../lib/safe-url.js';
const LinkSchema = z
    .object({
    label: z.string(),
    href: z.string(),
})
    .strict();
export const LinkListPropsSchema = z
    .object({
    title: z.string().optional(),
    links: z.array(LinkSchema),
})
    .strict();
/**
 * Renders a `link_list` block. Agent-supplied hrefs are restricted to
 * `http:`/`https:`/`mailto:`; anything else is dropped (rendered as
 * unlinked text) rather than executed.
 */
export function LinkListPrimitive({ title, links }) {
    return (_jsx(BlockCard, { title: title, children: _jsx("ul", { className: "space-y-1.5", children: links.map((link, index) => {
                const href = sanitizeHref(link.href);
                return (_jsx("li", { className: "text-sm", children: href ? (_jsxs("a", { href: href, target: "_blank", rel: "noopener noreferrer nofollow", className: "font-medium text-primary underline-offset-4 hover:underline", children: [link.label, _jsx("span", { "aria-hidden": true, className: "ml-0.5 text-xs", children: "\u2197" })] })) : (_jsx("span", { className: "text-muted-foreground", title: "Link removed: unsupported URL scheme", children: link.label })) }, index));
            }) }) }));
}
